import React from "react";
import { Checkbox, Form, Input, InputNumber, Radio } from "antd";

const { TextArea } = Input;

function AggregationMarkets({ plainOptions, form, dataMarketChannel }) {
  const millingAvailable = Form.useWatch("millingAvailable", form);
  const millingSufficient = Form.useWatch("millingSufficient", form);

  return (
    <>
      <div className="custom-title !text-[#111928] rounded-[.5rem]">
        Aggregation and Markets
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          name="aggregationPoints"
          label={"Availability of Aggregation Points / Warehouses"}
        >
          <Radio.Group options={plainOptions} />
        </Form.Item>
        <Form.Item
          name="millingAvailable"
          label={"Availability of Milling Facilities"}
        >
          <Radio.Group options={plainOptions} />
        </Form.Item>

        {millingAvailable === "Yes" && (
          <>
            <Form.Item
              name="millingCapacity"
              label={"Milling Capacity (Tonnage per hour)"}
            >
              <InputNumber
                min={0}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                placeholder="Enter value"
                className="input flex"
              />
            </Form.Item>
            <Form.Item
              name="millingSufficient"
              label={"Is the milling capacity sufficient?"}
            >
              <Radio.Group options={plainOptions} />
            </Form.Item>

            {millingSufficient && (
              <Form.Item
                name="millingSufficientDesc"
                label={"Describe the sufficiency"}
              >
                <TextArea
                  rows={3}
                  placeholder={
                    millingSufficient === "Yes"
                      ? "Explain how the capacity meets the scheme's needs"
                      : "Explain the shortfall and how it affects the scheme"
                  }
                  className="text_area"
                />
              </Form.Item>
            )}
          </>
        )}

        <Form.Item name="marketChannelIds" label={"Market Channels"}>
          <Checkbox.Group
            options={
              dataMarketChannel?.map((item) => ({
                value: item?.mcId,
                label: item?.mcChannel,
              })) ?? []
            }
          />
        </Form.Item>
      </div>
    </>
  );
}

export default AggregationMarkets;
